<template>
  <div>
      <!-- <article class="message">
          <div class="message-header">
              <span class="icon"><i class="fa fa-info-circle"></i></span>
              <strong>Click + hold + drag</strong> to move the table. <strong>Double-click</strong> to release text selection.
          </div>
      </article> -->
    <div style="overflow: auto; overflow-y: auto; overflow-y: hidden;max-width: 100%;" >

      <table :class="tableClass" style="width: 100%;">
        <thead>
        <tr>
          <th v-if="checkbox">
            <input type="checkbox" @change="toggleAllCheckboxes($event.target.checked)" :checked="checkAll">
          </th>
          <th :class="column.title.columnClass" v-for="column in columns" contenteditable="true">
            <template v-if="isSortable(column.content)">
            <a href="#" @click="orderBy($event, column.content)">
              <span class="icon" v-if="appendParams.sort.field == column.content.data">
                <i class="fa fa-fw "
                   v-bind:class="{
                  'fa-caret-down':  appendParams.sort.direction === 'asc',
                  'fa-caret-up':  appendParams.sort.direction === 'desc'
                }"></i>
              </span>
              <span>
                {{column.title.caption}}
              </span>
            </a>
            </template>
            <template v-else>
              <span>
                {{column.title.caption}}
              </span>
            </template>
          </th>
        </tr>
        </thead>
        <tbody>
        <template v-for="content in data">
          <tr :class="onRowCallback(content)">
            <td v-if="checkbox">
              <input v-if="getShowCheckBox(content)" type="checkbox" @change="toggleCheckbox($event.target.checked, content)" :checked="isSelected(content)">
            </td>
            <template v-for="column in columns">
              <template v-if="hasCallback(column.content)">
                <td :class="column.content.fieldClass">
                  {{ callCallback(column.content, content) }}
                </td>
              </template>
              <template v-else>
                <template v-if="column.content.type == undefined">
                  <td :class="column.content.fieldClass">
                    {{content[column.content.data]}}
                  </td>
                </template>
                <template v-else>
                  <td :class="column.content.fieldClass">
                    <template v-if="column.content.type == 'tooltip' && column.content.tooltip == undefined">
                      <tooltip :label="content[column.content.data]" type="default" placement="left">
                        <a class="is-small">
                          {{ callCallback(column.content, content) }}
                        </a>
                      </tooltip>
                    </template>
                     <template v-else-if="column.content.type == 'tooltip' && column.content.tooltip.length > 0">
                      <tooltip :label="callCallback(column.content, content)" type="default" placement="left">
                        <a class="is-small">
                          {{ callCallback(column.content, content).substring(0, 25) }}
                        </a>
                      </tooltip>
                    </template>
                    <template v-else-if="column.content.type == 'link-modal' || column.content.type == 'link-modal|style'">
                      <template v-if="String(callCallback(column.content, content)).toLowerCase() !== 'false'">
                        <template v-if="column.content.type == 'link-modal|style'">
                          <a @click="$parent[column.content.fieldCallback](String(callCallback(column.content, content)))" :style="$parent[column.content.styleCallback](content)">
                            {{callCallback(column.content, content)}}
                          </a>
                        </template>
                        <template v-else>
                          <a @click="$parent[column.content.fieldCallback](String(callCallback(column.content, content)))">
                            {{callCallback(column.content, content)}}
                          </a>
                        </template>
                      </template>
                      <template v-else>
                        {{callCallback(column.content, content)}}
                      </template>
                    </template>
                    <template v-else-if="column.content.type == 'field-component'">
                      <component :is="column.content.data" :data="content"></component>
                    </template>
                  </td>
                </template>
              </template>
            </template>
          </tr>
        </template>
        </tbody>
      </table>
    </div>
    <hyper-table-pagination :pagination="pagination" :data="data"></hyper-table-pagination>
  </div>
</template>

<script>
  import Tooltip from 'vue-bulma-tooltip'
  import HyperTablePagination from './HyperTablePagination.vue'
  export default {
    components: {
      HyperTablePagination,
      Tooltip
    },
    props: {
      columns: {
        type: Array,
        required: true
      },
      tableClass: {
        type: String,
        default: ''
      },
      checkbox: {
        type: Boolean,
        default: false
      },
      queryParams: {
        type: Object,
        default: function () {
          return {
            sort: 'sort',
            page: 'page',
            per_page: 'per_page'
          }
        }
      },
      disableSelect: {
        type: Array,
        default: function () {
          return null
        }
      },
      disableFunction: {
        type: String,
        default: function () {
          return null
        },
        required: false
      },
      appendParams: {
        type: Object,
        default: function () {
          return {}
        }
      },
      rowCallback: {
        type: String,
        default: ''
      },
      url: {
        type: String,
        default: ''
      },
      prevent: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        data: [],
        pagination: {
          total: 0,
          per_page: 10,
          current_page: 1,
          last_page: 0,
          next_page_url: null,
          prev_page_url: null,
          from: 1,
          to: 10
        },
        selected: [],
        checkAll: false
      }
    },
    watch: {
      appendParams () {
        // this.loadData()
      }
    },
    beforeMount () {

    },
    mounted () {
      if (this.prevent === false) {
        // this.loadData()
      }
    },
    methods: {
      navigate (page) {
        this.currentPage = page
        this.loadData(page)
      },
      loadData (refresh) {
        if (refresh === true) {
          this.currentPage = 1
        }
        this.selected = []
        this.checkAll = false
        this.$emit('selected', this.selected)
        this.$http.get(this.$store.state.config.apiURL + '/' + this.url, {params: this.getAllQueryParams()}).then((response) => {
          this.$delete(this.pagination, 'pagination')
          this.data = response.body.data
          this.pagination.total = response.body.total
          this.pagination.per_page = response.body.per_page
          this.pagination.current_page = response.body.current_page
          this.pagination.last_page = response.body.last_page
          this.pagination.next_page_url = response.body.next_page_url
          this.pagination.prev_page_url = response.body.prev_page_url
          this.pagination.from = response.body.from
          this.pagination.to = response.body.to
          this.$set(this.pagination, 'pagination', this.pagination)
        }, (response) => {
          // error callback
        })
      },
      getAllQueryParams () {
        let params = {}
        params[this.queryParams.page] = this.currentPage
        for (let x in this.appendParams) {
          if (x === 'sort') {
            params[x] = this.getDefaultSortParam()
          } else {
            if (params[x] !== '') {
              params[x] = this.appendParams[x]
            }
          }
        }
        return params
      },
      getSortParam () {
        if (!this.appendParams.sort || this.appendParams.sort.field === '') {
          return ''
        }
        return this.getDefaultSortParam()
      },
      getDefaultSortParam () {
        let result = ''
        let fieldName = this.appendParams.sort.field
        result = fieldName + '|' + this.appendParams.sort.direction
        return result
      },
      isSortable (field) {
        return !(typeof field.sort === 'undefined')
      },
      orderBy (event, field) {
        event.preventDefault()
        if (!this.isSortable(field)) return
        this.singleColumnSort(field)
        this.currentPage = 1
        this.loadData()
      },
      singleColumnSort: function (field) {
        if (this.appendParams.sort.field === field.data) {
          this.appendParams.sort.direction = this.appendParams.sort.direction === 'asc' ? 'desc' : 'asc'
        } else {
          this.appendParams.sort.direction = 'asc'
        }
        this.appendParams.sort.field = field.data
        this.appendParams.sort.sort = field.sort
        this.$emit('sort', this.appendParams.sort)
      },
      hasCallback: function (column) {
        if (column.hasOwnProperty('callBack') && (column.callBack !== '') && (column.callBack !== undefined) && (column.type === undefined)) {
          return true
        } else {
          return false
        }
      },
      callCallback: function (field, content) {
        var args = field.callBack.split('|')
        var func = args.shift()
        if (typeof this.$parent[func] === 'function') {
          if (args.length > 0) {
            let data = [content[field.data]]
            for (field in args) {
              data.push(content[args[field]])
            }
            return this.$parent[func](data)
          } else {
            return this.$parent[func](content[field.data])
          }
        }
        return null
      },
      onRowCallback (content) {
        var func = this.rowCallback.trim()
        if (func !== '' && typeof this.$parent[func] === 'function') {
          return this.$parent[func](content)
        }
        return ''
      },
      toggleCheckbox (isChecked, data) {
        if (isChecked) {
          this.selected.push(data)
        } else {
          let selectedItens = this.selected
          for (var i = 0; i < selectedItens.length; i++) {
            if (selectedItens[i].id === data.id) {
              this.selected.splice(i, 1)
            }
          }
        }
        if (this.selected.length < this.pagination.per_page) {
          this.checkAll = false
        } else {
          this.checkAll = true
        }
        this.$emit('selected', this.selected)
      },
      toggleAllCheckboxes (isChecked) {
        if (isChecked) {
          for (var i = 0; i < this.data.length; i++) {
            if (!this.isSelected(this.data[i])) {
              if (this.disableFunction) {
                if (this.$parent[this.disableFunction](this.data[i])) {
                  this.selected.push(JSON.parse(JSON.stringify(this.data[i])))
                }
              } else {
                this.selected.push(JSON.parse(JSON.stringify(this.data[i])))
              }
            }
          }
          this.checkAll = true
        } else {
          this.selected = []
          this.checkAll = false
        }
        this.$emit('selected', this.selected)
      },
      getShowCheckBox (content) {
        if (this.disableSelect) {
          for (var i = 0; i < this.disableSelect.length; i++) {
            if (content.id === this.disableSelect[i].id) {
              for (var x = 0; x < this.data.length; x++) {
                if (this.disableSelect[i].id === this.data[x].id) {
                  this.checkAll = false
                  return false
                }
              }
            }
          }
          return true
        } else if (this.disableFunction) {
          return this.$parent[this.disableFunction](content)
        } else {
          return true
        }
      },
      isSelected: function (data) {
        for (var i = 0; i < this.selected.length; i++) {
          if (this.selected[i].id === data.id) {
            return true
          }
        }
        return false
      },
      refreshSelected (data) {
        for (var i = 0; i < this.selected.length; i++) {
          if (this.selected[i].id === data.id) {
            this.selected.splice(i, 1)
          }
        }
      },
      showPerPage (perPage) {
        this.pagination.per_page = perPage
        this.$emit('perPage', perPage)
        this.loadData(true)
      },
      clear () {
        this.data = []
        this.selected = []
        this.$delete(this.pagination, 'pagination')
        this.pagination.total = 0
        this.pagination.per_page = 10
        this.pagination.current_page = 1
        this.pagination.last_page = 0
        this.pagination.next_page_url = null
        this.pagination.prev_page_url = null
        this.pagination.from = 1
        this.pagination.to = 10
        this.$set(this.pagination, 'pagination', this.pagination)
      },
      clearSelected () {
        this.selected = []
        this.$emit('selected', this.selected)
      }
    }
  }
</script>
<style lang="scss" scoped>
  .is-title {
    text-transform: capitalize;
  }
  .is-danger {
    background-color: rgb(255,179,186) !important;
  }
  .is-warning {
    background-color: rgb(252,255,179) !important;
  }
  .is-success {
    background-color: rgb(159,255,135) !important;
  }
  .table tbody tr td, .table thead tr th {
    white-space: nowrap;
  }
</style>



// WEBPACK FOOTER //
// HyperTable.vue?19b9a716